import React from 'react';
import { cn } from '../../lib/utils';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  fullScreen?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({ 
  size = 'lg', 
  className,
  fullScreen = true 
}) => {
  const sizeClasses = {
    sm: 'size-8 border-2',
    md: 'size-12 border-3',
    lg: 'size-16 border-4',
  };

  const spinnerElement = (
    <div className="relative">
      <div 
        className={cn(
          'border-gray-200 border-t-primary rounded-full animate-spin',
          sizeClasses[size],
          className
        )}
      />
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        {spinnerElement}
      </div>
    );
  }

  return spinnerElement;
};

export default Spinner;